function Footer() {
    return (
        <div id="footer">
            <p>&copy; 2023 Ian McMahon</p>
        </div>
    );
}

export default Footer;